// extracted by mini-css-extract-plugin
export default {"footnotes":"Footnotes-module__footnotes--F_v5O"};